/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/typedef */
export abstract class Transformer<S, TS, F, TF> {
  public sendCollection(data: S[]): TS[] {
    return data.map(datum => this.send(datum));
  }

  public fetchCollection(data: F[]): TF[] {
    return data.map(collectionData => this.fetch(collectionData));
  }

  /*
   * public sendObjectCollection<A = any, B = any>(data: { [key: string]: A }): { [key: string]: B } {
   *   const transformed: { [key: string]: B } = {};
   *   Object.keys(data).forEach((key) => {
   *     transformed[key] = this.send(data[key]);
   *   });
   *
   *   return transformed;
   * }
   *
   * public fetchObjectCollection<A = any, B = any>(data: { [key: string]: A }): { [key: string]: B } {
   *   const transformed: { [key: string]: B } = {};
   *   Object.keys(data).forEach((key) => {
   *     transformed[key] = this.fetch(data[key]);
   *   });
   *
   *   return transformed;
   * }
   */

  public abstract send(data: S): TS;

  public abstract fetch(data: F): TF;
}
